const CLASS_WIZARD = 'CLASS_WIZARD';
const CLASS_NECROMANCER = 'CLASS_NECROMANCER';
const CLASS_WITCH_DOCTOR = 'CLASS_WITCH_DOCTOR';
const CLASS_MONK = 'CLASS_MONK';
const CLASS_DEMON_HUNTER = 'CLASS_DEMON_HUNTER';
const CLASS_BARBARIAN = 'CLASS_BARBARIAN';
const CLASS_CRUSADER = 'CLASS_CRUSADER';

export const classesArray = [
  CLASS_DEMON_HUNTER,
  CLASS_MONK,
  CLASS_NECROMANCER,
  CLASS_WITCH_DOCTOR,
  CLASS_WIZARD,
  CLASS_BARBARIAN,
  CLASS_CRUSADER,
];

export default {
  wizard: CLASS_WIZARD,
  necromancer: CLASS_NECROMANCER,
  witchDoctor: CLASS_WITCH_DOCTOR,
  monk: CLASS_MONK,
  demonHunter: CLASS_DEMON_HUNTER,
  barbarian: CLASS_BARBARIAN,
  crusader: CLASS_CRUSADER,
};
